var _defs, _path, _path2, _rect, _path3, _path4, _path5, _line, _line2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ee3bb47c-97de-4e96-8a19-550ab45dcb69",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ab3e0e94-1df3-44ab-b232-4235d8750a4d,.b2aeec30-e13c-4caa-af47-29eb0494309f{fill:none;}.ab3e0e94-1df3-44ab-b232-4235d8750a4d,.aeeae480-e2b7-486f-808c-6699cd68ae3d{stroke:#8e8e8e;}.ab3e0e94-1df3-44ab-b232-4235d8750a4d,.aeeae480-e2b7-486f-808c-6699cd68ae3d,.b2aeec30-e13c-4caa-af47-29eb0494309f{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.aeeae480-e2b7-486f-808c-6699cd68ae3d,.f919ec1f-8c96-489c-8f65-7979e25b3879{fill:#ea3d3e;}.b393dfeb-8ca4-4474-ba08-def5bdb56442{fill:#fff;}.b2aeec30-e13c-4caa-af47-29eb0494309f{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ab3e0e94-1df3-44ab-b232-4235d8750a4d",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aeeae480-e2b7-486f-808c-6699cd68ae3d",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "f919ec1f-8c96-489c-8f65-7979e25b3879",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b393dfeb-8ca4-4474-ba08-def5bdb56442",
    d: "M43.3,62.3h2.5a4.3,4.3,0,0,1,2.8.8,2.6,2.6,0,0,1,.9,2.1,3.3,3.3,0,0,1-.8,2.2,4.3,4.3,0,0,1-3.1,1.1h-1v4H43.3Zm1.3,4.9h1.1c1.5,0,2.5-.7,2.5-2.1s-.9-2-2.4-2H44.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b393dfeb-8ca4-4474-ba08-def5bdb56442",
    d: "M51.3,62.4a11.4,11.4,0,0,1,2.7-.2,5.9,5.9,0,0,1,4.1,1.2A4.6,4.6,0,0,1,59.5,67a5.7,5.7,0,0,1-1.4,4,6.5,6.5,0,0,1-4.5,1.4H51.3Zm1.3,8.9h1.3c2.8,0,4.3-1.6,4.3-4.3s-1.3-3.9-4.1-3.9H52.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b393dfeb-8ca4-4474-ba08-def5bdb56442",
    d: "M61.2,62.2h5.5v1.1H62.5v3.4h3.9v1.1H62.5v4.5H61.2Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b2aeec30-e13c-4caa-af47-29eb0494309f",
    x1: 45.7,
    y1: 41.2,
    x2: 33.2,
    y2: 41.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b2aeec30-e13c-4caa-af47-29eb0494309f",
    x1: 45.7,
    y1: 51,
    x2: 33.2,
    y2: 51
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b2aeec30-e13c-4caa-af47-29eb0494309f",
    x: 50.6,
    y: 41.2,
    width: 10.7,
    height: 9.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3a024f1172dffc71cd0caeeb4199f939.svg";
export { ForwardRef as ReactComponent };